export default "__VITE_ASSET__B1kw1zfh__"